import React, { memo } from 'react';
import styled, { css } from 'styled-components';

import { SIZES, TYPES, LINK_COLOR } from '@front/common/src/constants/link';
import { CommonTextButtonProps } from '@front/common/src/types/components';

import { FONT_WEIGHTS } from '../base-text/base-text';
import { StylelessButton } from '../utils';
import { linkStyle } from '../link/common';
import Text from '../base-text/variants/text';
import { TextVariantProps } from '../base-text/variants/type';

export const disabledStyle = css`
  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
`;

const StyledButton = styled(StylelessButton)<{ $color: string }>`
  ${({ $color }) => linkStyle($color)}
  ${disabledStyle};
`;

const TEXT_VARIANT_BY_SIZE: Record<NonNullable<TextButtonProps['size']>, React.FC<TextVariantProps>> = {
  md: Text.MDMedium,
  sm: Text.SMMedium,
};

// TODO replace onClick with onPress
export type TextButtonProps = CommonTextButtonProps & {
  label?: string;
  isDisabled?: boolean;
  className?: string;
  onClick?: (event: React.MouseEvent<HTMLButtonElement>) => void;
};

const TextButton = ({
  children,
  isDisabled = false,
  label,
  onClick,
  className,
  type = 'normal',
  size = 'md',
}: TextButtonProps) => {
  const textColor = LINK_COLOR[type];
  const TextVariant = TEXT_VARIANT_BY_SIZE[size];

  return (
    <StyledButton
      onClick={onClick}
      disabled={isDisabled}
      aria-label={label}
      type='button'
      className={className}
      $color={textColor}
    >
      <TextVariant color={textColor}>{children}</TextVariant>
    </StyledButton>
  );
};

export { SIZES, TYPES, FONT_WEIGHTS };
export default memo(TextButton);
